import { $httpAdmin, $httpAdminSync } from "../../api/http";
import { type AxiosPromise } from "../../modules/axios";
import type { IPaged } from '../../types/common';
import { pick } from "../../util/object";

export interface IProduct {
  id: number,
  sort: number,
  products: string;
  content: string,
  url: string;
}

export function apiProductsGet(): AxiosPromise<IProduct[]> {
  return $httpAdmin.get('/products/selectproducts');
}

export async function apiProductsAdd(params: Omit<IProduct, "id">): Promise<AxiosPromise> {
  await $httpAdminSync.post('/products/productsadd', params);
  return $httpAdmin.post('/products/productsadd', params);
}

export async function apiProductsUpdate(params: Partial<IProduct>): Promise<AxiosPromise> {
  await $httpAdminSync.patch('/products/productsupdate', pick(params, ['id', 'content']));
  return $httpAdmin.patch('/products/productsupdate', params);
}

export async function apiProductsDelete(id: IProduct['id']): Promise<AxiosPromise> {
  await $httpAdminSync.delete(`/products/productsdeleteById/${id}`);
  return $httpAdmin.delete(`/products/productsdeleteById/${id}`);
}

export interface IMosFET {
  mosfetsId: number;
  productsId: number;
  partNo: string;
  pdf: string;
  esd: string;
  packageType: string;
  configuration: string;
  mosfetType: string;
  vds: string;
  vgs: string;
  rds10v: string;
  rds4v: string;
  rds2v: string;
  rds1v: string;
  id: string;
}

export interface IApiPMosGet extends Partial<IMosFET> {
  start: number;
  limit: number;
}

export function apiMosGet(params: IApiPMosGet): AxiosPromise<IPaged<IMosFET>> {
  return $httpAdmin.post('/products/mtmosfetspage', params);
}

export async function apiMosAdd(params: Omit<IMosFET, "mosfetsId">): Promise<AxiosPromise> {
  await $httpAdminSync.post('/products/mtmosfetsadd', params);
  return $httpAdmin.post('/products/mtmosfetsadd', params);
}

export async function apiMosUpdate(params: Partial<IMosFET>): Promise<AxiosPromise> {
  await $httpAdminSync.patch('/products/mtmosfetsupdate', params);
  return $httpAdmin.patch('/products/mtmosfetsupdate', params);
}

export async function apiMosDelete(id: IMosFET['mosfetsId']): Promise<AxiosPromise> {
  await $httpAdminSync.delete(`/products/mosfetsdeleteById/${id}`);
  return $httpAdmin.delete(`/products/mosfetsdeleteById/${id}`);
}

export function apiMosSearchOptions(): AxiosPromise<Record<keyof IMosFET, string[]>> {
  return $httpAdmin.get('/products/mtmosfetsoption');
}

export interface Diode {
  id: number,
  ioa: string,
  vrrma: string,
  ifsma: string,
  vfa: string,
  vfifa: string,
  irvrv: string,
  iruA: string,
  partNumber: string,
  package: string;
}

export function apiDiodeGet(params: { start: number, limit: number; }): AxiosPromise<IPaged<Diode>> {
  return $httpAdmin.post('/products/mtejgpage', params);
}

export interface Triode {
  id: number,
  bvceov: string,
  bvcbov: string,
  bvebov: string,
  hfeMinMax: string,
  partNumber: string,
  package: string,
  polarity: string,
  icmA: string,
  vcesatV: string,
  pcmmW: string;
}

export function apiTriodeGet(params: { start: number, limit: number; }): AxiosPromise<IPaged<Triode>> {
  return $httpAdmin.post('/products/mtsjgpage', params);
}

export interface IC {
  id: number,
  vov: string,
  virocv: string,
  partNumber: string,
  package: string,
  pdmW: string,
  iomA: string;
}

export function apiICGet(params: { start: number, limit: number; }): AxiosPromise<IPaged<IC>> {
  return $httpAdmin.post('/products/mtjcdlpage', params);
}